import { render } from "./stylitics-recommendations.vue?vue&type=template&id=de513114"
import script from "./stylitics-recommendations.vue?vue&type=script&lang=js"
export * from "./stylitics-recommendations.vue?vue&type=script&lang=js"

import "./stylitics-recommendations.vue?vue&type=style&index=0&id=de513114&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__